module.exports = __webpack_public_path__ + "img/level_1.b6975510.png";